"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasProfanity = hasProfanity;
exports.truncateMessage = truncateMessage;
exports.cleanMessage = cleanMessage;
exports.cleanNumber = cleanNumber;
const censor_sensor_1 = require("censor-sensor");
const censorSensor = new censor_sensor_1.CensorSensor();
censorSensor.disableTier(2);
censorSensor.disableTier(3);
censorSensor.disableTier(4);
function hasProfanity(check) {
    return censorSensor.isProfane(check);
}
function truncateMessage(message) {
    return message.substring(0, 200);
}
function cleanMessage(msg) {
    return censorSensor.cleanProfanity(msg).trim();
}
// make sure numbers are cleaned up appropriately because js lets you do some dumb shit
function cleanNumber(num, defaultValue = 0, opts = {}) {
    num = +num;
    if (isNaN(num))
        return defaultValue;
    if (!isFinite(num))
        return defaultValue;
    if (opts.round)
        num = Math.round(num);
    if (opts.floor)
        num = Math.floor(num);
    if (opts.abs)
        num = Math.abs(num);
    return num;
}
